import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4791d9f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row card_list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "クリックすると最大化します。", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  height: "188px",
  style: {"max-height":"550px","min-height":"188px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-block" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = {
  id: "ar-marker",
  class: "text-center"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-between"
}
const _hoisted_10 = { class: "marker" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"text-align":"center","font-size":"100px"} }

import { onMounted, ref } from 'vue';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import { ArMarker } from './ArMarker';
import { DialogHandler } from './DialogHandler';
import { translation } from '../../lang/Translation';

/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ArMarkerListDialog',
  setup(__props) {

const t = translation;//
const pageTitle = t.to("ARマーカー一覧",'ar_marker_title');
const selectedItem = ref(new ArMarker());
const dialogId = DialogHandler.arMarkerListDialogId;
const list = ref([]);

/**
 * ARマーカーデータ
 */
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    list.value = ArMarker.list;
  });
});

const selectRow = (item: ArMarker) => {
  selectedItem.value = item;
};
const returnToList = () => {
  selectedItem.value = new ArMarker();
};

const print = () => {
  document.querySelectorAll('body > :not(#ar-marker) , .show').forEach((el) => el.classList.add('print-off'));
  window.print();
  document.querySelectorAll('.print-off').forEach((el) => el.classList.remove('print-off'));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-xl': true },
    title: _unref(pageTitle)
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "col-sm-4 col-xs-6 col-lg-3"
          }, [
            _createTextVNode(_toDisplayString(item.id) + " ", 1),
            _createElementVNode("div", {
              class: "card",
              height: "188px",
              onClick: ($event: any) => (selectRow(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "card-img-top img-responsive",
                    width: "100%",
                    src: item.img,
                    lazyload: ""
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", _hoisted_7, _toDisplayString(item.title), 1)
                ])
              ])
            ], 8, _hoisted_3)
          ]))
        }), 128))
      ], 512), [
        [_vShow, !selectedItem.value.id]
      ]),
      _createElementVNode("div", _hoisted_8, [
        (selectedItem.value.id)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: returnToList
              }, "リストに戻る"),
              _createElementVNode("span", null, _toDisplayString(selectedItem.value.id), 1),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: print
              }, "印刷")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            class: "ar_marker",
            src: selectedItem.value.img,
            width: "360"
          }, null, 8, _hoisted_11),
          _createElementVNode("h1", _hoisted_12, _toDisplayString(selectedItem.value.id), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})